

export let spriteOpts = [


  // {
  //   src: "/pixi/bottle-wine.png",
  //   tags: [ "bottle", "wine" ],
  // },

  // {
  //   src: "/pixi/chair-cushion.png",
  //   tags: [ "chair", "cushion" ],
  // },
  // {
  //   src: "/pixi/chair-office.png",
  //   tags: [ "chair", "office" ],
  // },
  // {
  //   src: "/pixi/table-office.png",
  //   tags: [ "table", "office" ],
  // },
  // {
  //   src: "/pixi/table-plastic.png",
  //   tags: [ "table", "plastic" ],
  // },


  {
    src: "/pixi/electronics-computer.png",
    tags: [ "electronic", "computer", "screen", "display", "office", "recycle", "plastic", "digital", "equipment" ],
  },
  {
    src: "/pixi/electronics-keyboard.png",
    tags: [ "electronic", "keyboard", "input", "plastic", "computer", "key", "office", "recycle", "digital", "equipment" ],
  },
  {
    src: "/pixi/electronics-laptop.png",
    tags: [ "electronic", "laptop", "computer", "screen", "display", "office", "recycle", "plastic", "confidential", "personal", "camera" ],
  },
  {
    src: "/pixi/electronics-mouse.png",
    tags: [ "electronic", "mouse", "input", "computer", "click", "office", "wire" ],
  },

  {
    src: "/pixi/bottle-energydrink.png",
    tags: [ "bottle", "plastic", "reuse", "recycle" ],
  },
  {
    src: "/pixi/bottle-glass.png",
    tags: [ "bottle", "glass", "tinted", "clear", "reuse", "recycle", "delicate" ],
  },
  {
    src: "/pixi/bottle-plastic.png",
    tags: [ "bottle", "plastic", "reuse", "recycle", "cleaning", "repurpose" ],
  },
  {
    src: "/pixi/bottle-spray.png",
    tags: [ "bottle", "spray", "plastic", "parts", "small", "reuse", "recycle", "cleaning", "repurpose" ],
  },
  {
    src: "/pixi/bottle-whiskey.png",
    tags: [ "bottle", "whiskey", "glass", "tinted", "colour", "reuse", "recycle", "alcohol", "delicate" ],
  },
  {
    src: "/pixi/bottle-wine.png",
    tags: [ "bottle", "wine", "glass", "tinted", "colour", "reuse", "recycle", "alcohol", "delicate" ],
  },

  {
    src: "/pixi/chair-cushion.png",
    tags: [ "chair", "furniture", "cushion", "home", "fabric", "rubber", "brown", "reuse", "recycle" ],
  },
  {
    src: "/pixi/chair-office.png",
    tags: [ "chair", "furniture", "office", "seating", "commercial", "wood", "plywood", "rubber", "brown", "reuse", "recycle" ],
  },
  {
    src: "/pixi/chair-plastic.png",
    tags: [ "chair", "furniture", "plastic", "home", "office", "rubber", "grey", "blue", "reuse", "recycle" ],
  },

  {
    src: "/pixi/lamp-bulb.png",
    tags: [ "lamp", "bulb", "small", "light", "home", "electric", "portable", "recycle", ],
  },
  {
    src: "/pixi/lamp-desk.png",
    tags: [ "lamp", "desk", "table", "light", "small", "portable", "recycle", "reuse", "metal", "craft", "home", "office", "wire", "bulb", "electric" ],
  },
  {
    src: "/pixi/lamp-floor.png",
    tags: [ "lamp", "shade", "floor", "corner", "light", "big", "portable", "recycle", "reuse", "metal", "home", "bulb", "electric" ],
  },
  {
    src: "/pixi/lamp-hanging.png",
    tags: [ "lamp", "hanging", "ceiling", "light", "small", "fixed", "recycle", "reuse", "metal", "wire", "home", "office" ],
  },
  {
    src: "/pixi/lamp-shade.png",
    tags: [ "lamp", "shade", "desk", "table", "light", "small", "portable", "recycle", "reuse", "metal", "craft", "home", "bulb" ],
  },
  {
    src: "/pixi/lamp-small.png",
    tags: [ "lamp", "small", "light", "home", "kerosene", "handheld", "portable", "recycle", "reuse", "metal", "craft" ],
  },
  {
    src: "/pixi/lamp-wall.png",
    tags: [ "lamp", "wall", "light", "home", "electric", "switch", "small", "fixed", "recycle", "reuse", "metal", "bulb" ],
  },

  {
    src: "/pixi/paper-books.png",
    tags: [ "paper", "books", "recycle", "reuse", "cardboard" ],
  },
  {
    src: "/pixi/paper-news.png",
    tags: [ "paper", "news", "recycle", "reuse", "big", "thin" ],
  },
  {
    src: "/pixi/paper-photos.png",
    tags: [ "paper", "photos", "home", "ink", "plastic", "private", "thick", "recycle", "reuse" ],
  },
  {
    src: "/pixi/paper-pictures.png",
    tags: [ "paper", "pictures", "home", "office", "ink", "plastic", "private", "recycle", "reuse" ],
  },
  {
    src: "/pixi/paper-prints.png",
    tags: [ "paper", "prints", "office", "home", "ink", "confidential", "private", "a4", "letter", "recycle" ],
  },
  {
    src: "/pixi/paper-receipts.png",
    tags: [ "paper", "receipts", "office", "confidential", "private", "financial", "thin", "small", "recycle" ],
  },
  {
    src: "/pixi/paper-recycle.png",
    tags: [ "paper", "recycle", "receipts", "print", "cardboard", "documents",  ],
  },

  {
    src: "/pixi/set-dining.png",
    tags: [ "table", "chair", "set", "dining", "wood", "brown", "home", "restaurant", "coffee" ],
  },

  {
    src: "/pixi/storage-metal-big.png",
    tags: [ "storage", "metal", "big", "drawers", "storage", "steel", "rubber", "paint", "grey", "office" ],
  },
  {
    src: "/pixi/storage-metal-small.png",
    tags: [ "storage", "metal", "small", "drawers", "storage", "steel", "rubber", "paint", "grey", "office" ],
  },
  {
    src: "/pixi/storage-wood-big.png",
    tags: [ "storage", "wood", "big", "drawers", "storage", "wood", "brown", "home", "office" ],
  },
  {
    src: "/pixi/storage-wood-small.png",
    tags: [ "storage", "wood", "small", "drawers", "storage", "wood", "brown", "home", "office" ],
  },

  {
    src: "/pixi/table-coffee.png",
    tags: [ "table", "coffee", "wood", "brown", "home", "store", "commercial", "short-use" ],
  },
  {
    src: "/pixi/table-dining.png",
    tags: [ "table", "dining", "wood", "brown", "home" ],
  },
  {
    src: "/pixi/table-dressing.png",
    tags: [ "table", "furniture", "dressing", "wood", "brown", "home", "mirror", "drawers", "storage" ],
  },
  {
    src: "/pixi/table-office.png",
    tags: [ "table", "desk", "furniture", "office", "glass", "metal", "rubber", "commercial", "print" ],
  },
  {
    src: "/pixi/table-plastic.png",
    tags: [ "table", "desk", "furniture", "plastic", "grey", "short-use", "blue" ],
  },
  {
    src: "/pixi/table-wood.png",
    tags: [ "table", "desk", "furniture", "wood", "desk", "plywood", "rubber", "brown" ],
  },

  {
    src: "/pixi/cup-beer.png",
    tags: [ "cup", "beer", "glass", "mug", "reuse" ],
  },
  {
    src: "/pixi/cup-ceramic.png",
    tags: [ "cup", "ceramic", "tea", "coffee", "china", "reuse", "delicate" ],
  },
  {
    src: "/pixi/cup-coffee.png",
    tags: [ "cup", "coffee", "paper", "recycle", "dispose", "single-use", "cardboard" ],
  },
  {
    src: "/pixi/cup-plastic.png",
    tags: [ "cup", "plastic", "recycle", "dispose", "single-use" ],
  },
  {
    src: "/pixi/cup-wine.png",
    tags: [ "cup", "wine", "glass", "reuse", "delicate" ],
  },

  {
    src: "/pixi/unknown-box-open-shine.png",
    tags: [ "unknown", "box", "open", "shine", "treasure" ],
  },
  {
    src: "/pixi/unknown-box-open.png",
    tags: [ "unknown", "box", "open" ],
  },
  {
    src: "/pixi/unknown-box-search.png",
    tags: [ "unknown", "box", "closed", "search", "find" ],
  },
  {
    src: "/pixi/unknown-box-taped.png",
    tags: [ "unknown", "box", "closed", "taped" ],
  },
  {
    src: "/pixi/unknown-box-taped2.png",
    tags: [ "unknown", "box", "closed", "taped" ],
  },
];


export let unknownSprites = spriteOpts.filter(s => s.tags.includes("unknown"));